interface IUserInfo {
  user_name: string;
  captcha: string;
  password: string;
}

export default class LoginDataHelper {
  // 去除user_name前后的空格
  static formatValue(values: IUserInfo) {
    const { user_name } = values;
    if (user_name) {
      return { ...values, user_name: user_name.trim() };
    }
    return values;
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/account/Login/LoginDataHelper.ts